export const FAQ_ITEMS = [
  {
    title: "Is Wi-Fi available?",
    desc: `Yes, Wi-Fi is available, but only in the garden area.`,
  },
  {
    title: "Is there a swimming pool?",
    desc: `Yes, the swimming pool is exclusively for resident guests. Swimming is allowed from 9 AM to 7 PM.`,
  },
  {
    title: "What are the check-in & check-out timings",
    desc: `Check-in time is flexible. Check-out is at 11 AM.`,
  },
  {
    title: "What are the rates for rooms?",
    desc: `	Place an enquiry to get the latest rates for rooms or contact us by clicking the button`,
  },
];
